import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { LuxonZone } from 'types/LuxonZone';
import { getEndOfSundayWeek, getStartOfSundayWeek } from 'utils/dateUtils';
import { getWeekRangeForTime } from 'utils/timeRangeUtils';
import { useOrganization } from '../';

export default function useWeeklyTimeRangeGet(zone: LuxonZone) {
  const organization = useOrganization();

  return useCallback(
    (time: number) => {
      if (organization.organizationOvertimePeriods) {
        const weekRange = getWeekRangeForTime(organization.organizationOvertimePeriods!, time, zone);

        if (weekRange) {
          return weekRange;
        }
      }

      const date = DateTime.fromSeconds(time, { zone });
      return { startTime: getStartOfSundayWeek(date), endTime: getEndOfSundayWeek(date) };
    },
    [organization.organizationOvertimePeriods, zone]
  );
}
